import { useEffect } from "react";

export const usePageMeta = (title, description, canonicalPath) => {
  useEffect(() => {
    document.title = title;
    const desc = document.querySelector('meta[name="description"]');
    if (desc && description) desc.setAttribute("content", description);
    if (canonicalPath) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", `https://trycoacher.com${canonicalPath}`);
    }
  }, [title, description, canonicalPath]);
};
